var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('div',[_c('v-row',{staticClass:"mt-10",attrs:{"justify":"center","align-content":"center"}},[_c('img',{attrs:{"src":require("../../assets/loading.gif")}})])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }